import AsyncStorage from '@react-native-async-storage/async-storage';

const VOLUME_CACHE_KEY = 'player-volume';
const MUTE_CACHE_KEY = 'player-mute';

/**
 * Volume cache should return null if the value is not set
 * @returns number | undefined
 */
export async function getCachedVolume(): Promise<number | null> {
  const volume = (await AsyncStorage.getItem(VOLUME_CACHE_KEY)) || '';

  const parsedVolume = parseFloat(volume);

  if (isNaN(parsedVolume)) return null;

  return parsedVolume;
}

export function setCachedVolume(volume: number): void {
  AsyncStorage.setItem(VOLUME_CACHE_KEY, `${volume}`);
}

/**
 * Mute cache should return null if the value is not set
 * @returns boolean | undefined
 */
export async function getCachedMute(): Promise<boolean | null> {
  const mute = await AsyncStorage.getItem(MUTE_CACHE_KEY);

  if (mute === 'true') return true;

  if (mute === 'false') return false;

  return null;
}

export function setCachedMute(mute: boolean): void {
  AsyncStorage.setItem(MUTE_CACHE_KEY, `${mute}`);
}
